import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const ButtonFilled = styled(Button)({
	background: '  #a05344 ',
	border: 0,
	borderRadius: '10px',
	color: 'white',

	padding: '15px',
	fontWeight: 'bold'
});

export default ButtonFilled;
